import {Component, input} from '@angular/core';

@Component({
  selector: 'lib-list-table',
  templateUrl: './list-table.component.html',
  styleUrl: './list-table.component.scss',
})
export class ListTableComponent {
  headers = input<string[]>([]);
}
